/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Basegamedescription3Inputs */

const id_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar pencapaian ini untuk game dasar.`)
};

const ms_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senarai pencapaian ini adalah untuk permainan asas.`)
};

const da_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne liste af achievements er for basespillet.`)
};

const de_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Liste von Errungenschaften ist für das Basisspiel.`)
};

const en_us2_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This list of achievements are for the base game.`)
};

const es_es2_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para el juego base.`)
};

const es_mx2_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de logros es para el juego base.`)
};

const fil_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang listahang ito ng achievement ay para sa base game.`)
};

const fr_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette liste de succès concerne le jeu de base.`)
};

const it_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo elenco di risultati è per il gioco base.`)
};

const hu_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a teljesítménylista az alapjátékhoz tartozik.`)
};

const nl_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze lijst met prestaties is voor het basisspel.`)
};

const no_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne listen over prestasjoner er for grunnspillet.`)
};

const pl_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta lista osiągnięć dotyczy gry podstawowej.`)
};

const pt_br2_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para o jogo base.`)
};

const pt_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta lista de conquistas é para o jogo base.`)
};

const ro_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această listă de realizări este pentru jocul de bază.`)
};

const fi_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä saavutuslista koskee peruspeliä.`)
};

const sv_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna lista med prestationer är för grundspelet.`)
};

const vi_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách thành tích này dành cho game cơ bản.`)
};

const tr_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu başarım listesi temel oyun içindir.`)
};

const cs_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento seznam úspěchů je pro základní hru.`)
};

const bg_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Този списък с постижения е за основната игра.`)
};

const ru_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот список достижений для базовой игры.`)
};

const uk_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей список досягнень для базової гри.`)
};

const ar_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة الإنجازات هذه للعبة الأساسية.`)
};

const hi_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियों की यह सूची बेस गेम के लिए है।`)
};

const th_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการความสำเร็จนี้สำหรับเกมหลัก`)
};

const ja_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この実績リストはベースゲーム用です。`)
};

const zh_cn2_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此成就列表属于基础游戏。`)
};

const zh_hant1_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此成就清單屬於基礎遊戲。`)
};

const ko_offerdetail_achievements_basegamedescription3 = /** @type {(inputs: Offerdetail_Achievements_Basegamedescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 도전 과제 목록은 기본 게임용입니다.`)
};

/**
* | output |
* | --- |
* | "This list of achievements are for the base game." |
*
* @param {Offerdetail_Achievements_Basegamedescription3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_basegamedescription3 = /** @type {((inputs?: Offerdetail_Achievements_Basegamedescription3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Basegamedescription3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "da") return da_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "de") return de_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "it") return it_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "no") return no_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "th") return th_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_basegamedescription3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_basegamedescription3(inputs)
	return ko_offerdetail_achievements_basegamedescription3(inputs)
});
export { offerdetail_achievements_basegamedescription3 as "offerDetail.achievements.baseGameDescription" }